
import config from '@/config/index'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getOrderDetail, getTelephone } from '@/api/pintuan'
export default {
components: { Group, Cell },
data () {
return {
baseUrl: config.baseUrl,
id: this.$route.params.id,
obj: {},
telephone: ''
}
},
mounted () {
this.getDetail()
this.getTelephone()
},
methods: {
getDetail () {
getOrderDetail({
id: this.id
}).then(res => {
this.obj = res.returnValue
})
},
getTelephone () {
getTelephone().then(res => {
this.telephone = res.returnValue.telephone
})
}
}
}
